import styled from 'styled-components';

const PublicLayoutWrapper = styled.div`
  * {
    box-sizing: border-box;
  }
  .main-public {
    height: 100vh;
    display: flex;
  }
  .public-image {
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--bg-public);
    flex: 1;

    img {
      width: 70%;
      height: auto;
    }

    @media only screen and (max-width: 575px) {
      display: none;
    }
  }
  .public-content {
    padding: 110px 52px 0;
    flex: 0 0 calc((432/1440) * 100%);

    @media only screen and (max-width: 575px) {
      flex: 1;
    }
  }
`;

export const PublicHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
  .public-header-title {
    font-weight: 600;
    font-size: 24px;
    margin-top: 35px;
  }
  .public-header-subtitle {
    font-weight: 400;
    font-size: 13px;
    margin-top: 25px;
  }
`;
export default PublicLayoutWrapper;
